export default __webpack_public_path__ + "static/media/expressJsLogo.632d3c32.svg";